import { memo } from 'react';
import { Clock } from 'lucide-react';
import type { NodeProps } from '@xyflow/react';
import type { ComposerNodeData } from '../../../types/composer';
import { ComposerNodeCard } from './ComposerNodeCard';

export const WaitNode = memo((props: NodeProps) => (
  <ComposerNodeCard
    {...props}
    data={props.data as ComposerNodeData}
    typeName="wait"
    glyph={<Clock size={14} strokeWidth={2.2} />}
  />
));

WaitNode.displayName = 'WaitNode';
